var map = {
	"./template1/American Cuisine/template.json": [
		"2b29",
		"chunk-2d0bd1ad"
	],
	"./template1/Balti/template.json": [
		"f4ee",
		"chunk-2d22cea4"
	],
	"./template1/Bangladeshi Cuisine/template.json": [
		"6554",
		"chunk-2d0cfa94"
	],
	"./template1/Breakfast/template.json": [
		"d833",
		"chunk-2d21eeaa"
	],
	"./template1/British Cuisine/template.json": [
		"24a3",
		"chunk-2d0b2aaa"
	],
	"./template1/Burgers/template.json": [
		"6170",
		"chunk-2d0cebca"
	],
	"./template1/Café/template.json": [
		"8655",
		"chunk-2d0de714"
	],
	"./template1/Cakes/template.json": [
		"a48e",
		"chunk-2d208356"
	],
	"./template1/Cantonese/template.json": [
		"3a24",
		"chunk-2d0c4246"
	],
	"./template1/Caribbean/template.json": [
		"c879",
		"chunk-2d217acd"
	],
	"./template1/Chicken/template.json": [
		"5e82",
		"chunk-2d0d3ac0"
	],
	"./template1/Chinese/template.json": [
		"4402",
		"chunk-2d0c0d78"
	],
	"./template1/Curry/template.json": [
		"b1f0",
		"chunk-2d20f1cf"
	],
	"./template1/Desserts/template.json": [
		"05b5",
		"chunk-2d0a45ce"
	],
	"./template1/Doughnuts/template.json": [
		"0b7d",
		"chunk-2d0ae9b5"
	],
	"./template1/Fast Food/template.json": [
		"b4de",
		"chunk-2d20fd09"
	],
	"./template1/Fish and Chips/template.json": [
		"1235",
		"chunk-2d0aa939"
	],
	"./template1/Grill/template.json": [
		"4bf0",
		"chunk-2d0cc0ae"
	],
	"./template1/Healthy/template.json": [
		"bdca",
		"chunk-2d21b116"
	],
	"./template1/Indian Cuisine/template.json": [
		"70a1",
		"chunk-2d0d617f"
	],
	"./template1/Italian Cuisine/template.json": [
		"a740",
		"chunk-2d208de8"
	],
	"./template1/Kebab/template.json": [
		"258f",
		"chunk-2d0b29a7"
	],
	"./template1/Lunch/template.json": [
		"0d70",
		"chunk-2d0af103"
	],
	"./template1/Middle Eastern Cuisine/template.json": [
		"10fa",
		"chunk-2d0aa810"
	],
	"./template1/Milkshakes/template.json": [
		"e225",
		"chunk-2d224c66"
	],
	"./template1/Noodles/template.json": [
		"4a55",
		"chunk-2d0cb703"
	],
	"./template1/Organic Food/template.json": [
		"4e93",
		"chunk-2d0cc681"
	],
	"./template1/Oriental Cuisine/template.json": [
		"c3a2",
		"chunk-2d216d17"
	],
	"./template1/Other/template.json": [
		"3770",
		"chunk-2d0ba533"
	],
	"./template1/Pakistani Cuisine/template.json": [
		"1b1c",
		"chunk-2d0b5d59"
	],
	"./template1/Pan Asian Restaurant/template.json": [
		"2d1c",
		"chunk-2d0bd93a"
	],
	"./template1/Peri-Peri/template.json": [
		"b847",
		"chunk-2d21060f"
	],
	"./template1/Persian Cuisine/template.json": [
		"8792",
		"chunk-2d0deb4e"
	],
	"./template1/Pizza/template.json": [
		"297b",
		"chunk-2d0b3888"
	],
	"./template1/Portuguese Cuisine/template.json": [
		"de5b",
		"chunk-2d229804"
	],
	"./template1/Roast Dinner/template.json": [
		"a12e",
		"chunk-2d207759"
	],
	"./template1/Salads/template.json": [
		"554a",
		"chunk-2d0c8643"
	],
	"./template1/Sandwiches/template.json": [
		"e958",
		"chunk-2d22670d"
	],
	"./template1/Sea Food/template.json": [
		"3ab7",
		"chunk-2d0c4819"
	],
	"./template1/Steak/template.json": [
		"ef7a",
		"chunk-2d231061"
	],
	"./template1/Subways/template.json": [
		"4985",
		"chunk-2d0c2138"
	],
	"./template1/Sushi/template.json": [
		"7085",
		"chunk-2d0d5c8c"
	],
	"./template1/Thai Cuisine/template.json": [
		"24be",
		"chunk-2d0b2afb"
	],
	"./template1/Turkish Cuisine/template.json": [
		"5d52",
		"chunk-2d0d36a2"
	],
	"./template1/Vegetarian/template.json": [
		"96ea",
		"chunk-2d0e616f"
	],
	"./template1/Waffles/template.json": [
		"d37d",
		"chunk-2d21dc92"
	],
	"./template1/juice bar/template.json": [
		"e09f",
		"chunk-2d2245ee"
	],
	"./template10/American Cuisine/template.json": [
		"29a4",
		"chunk-2d0b3d70"
	],
	"./template10/Balti/template.json": [
		"228d",
		"chunk-2d0b1e62"
	],
	"./template10/Bangladeshi Cuisine/template.json": [
		"86d9",
		"chunk-2d0decc9"
	],
	"./template10/Breakfast/template.json": [
		"391e",
		"chunk-2d0bac30"
	],
	"./template10/British Cuisine/template.json": [
		"e490",
		"chunk-2d2254bc"
	],
	"./template10/Burgers/template.json": [
		"5d61",
		"chunk-2d0d36c0"
	],
	"./template10/Café/template.json": [
		"7d8d",
		"chunk-2d0e1fef"
	],
	"./template10/Cakes/template.json": [
		"44e6",
		"chunk-2d0c13e7"
	],
	"./template10/Cantonese/template.json": [
		"37e1",
		"chunk-2d0baac6"
	],
	"./template10/Caribbean/template.json": [
		"ed8e",
		"chunk-2d230902"
	],
	"./template10/Chicken/template.json": [
		"0e8e",
		"chunk-2d0af518"
	],
	"./template10/Chinese/template.json": [
		"12e1",
		"chunk-2d0aaf43"
	],
	"./template10/Curry/template.json": [
		"b728",
		"chunk-2d210211"
	],
	"./template10/Desserts/template.json": [
		"cb9f",
		"chunk-2d2218e2"
	],
	"./template10/Doughnuts/template.json": [
		"dedf",
		"chunk-2d229db9"
	],
	"./template10/Fast Food/template.json": [
		"78aa",
		"chunk-2d0d7fb7"
	],
	"./template10/Fish and Chips/template.json": [
		"2203",
		"chunk-2d0b1d39"
	],
	"./template10/Grill/template.json": [
		"9279",
		"chunk-2d0e4cb1"
	],
	"./template10/Healthy/template.json": [
		"b976",
		"chunk-2d210a2c"
	],
	"./template10/Indian Cuisine/template.json": [
		"dd68",
		"chunk-2d229438"
	],
	"./template10/Italian Cuisine/template.json": [
		"78f9",
		"chunk-2d0d802a"
	],
	"./template10/Kebab/template.json": [
		"5771",
		"chunk-2d0c8df2"
	],
	"./template10/Lunch/template.json": [
		"9b92",
		"chunk-2d0f0118"
	],
	"./template10/Middle Eastern Cuisine/template.json": [
		"545c",
		"chunk-2d0c82a3"
	],
	"./template10/Milkshakes/template.json": [
		"9506",
		"chunk-2d0e5718"
	],
	"./template10/Noodles/template.json": [
		"16aa",
		"chunk-2d0abdfb"
	],
	"./template10/Organic Food/template.json": [
		"57a1",
		"chunk-2d0c9308"
	],
	"./template10/Oriental Cuisine/template.json": [
		"5ed7",
		"chunk-2d0d4019"
	],
	"./template10/Other/template.json": [
		"6f87",
		"chunk-2d0db2e5"
	],
	"./template10/Pakistani Cuisine/template.json": [
		"dd8a",
		"chunk-2d22949f"
	],
	"./template10/Pan Asian Restaurant/template.json": [
		"7dba",
		"chunk-2d0e2502"
	],
	"./template10/Peri-Peri/template.json": [
		"a888",
		"chunk-2d20922d"
	],
	"./template10/Persian Cuisine/template.json": [
		"de1a",
		"chunk-2d229787"
	],
	"./template10/Pizza/template.json": [
		"55da",
		"chunk-2d0c8c13"
	],
	"./template10/Portuguese Cuisine/template.json": [
		"7ae5",
		"chunk-2d0e19f0"
	],
	"./template10/Roast Dinner/template.json": [
		"7c1b",
		"chunk-2d0e1b53"
	],
	"./template10/Salads/template.json": [
		"c8df",
		"chunk-2d21806d"
	],
	"./template10/Sandwiches/template.json": [
		"7d5f",
		"chunk-2d0e1f94"
	],
	"./template10/Sea Food/template.json": [
		"12c6",
		"chunk-2d0aaf0a"
	],
	"./template10/Steak/template.json": [
		"a83a",
		"chunk-2d2091bb"
	],
	"./template10/Subways/template.json": [
		"934f",
		"chunk-2d0e5042"
	],
	"./template10/Sushi/template.json": [
		"a683",
		"chunk-2d208aa6"
	],
	"./template10/Thai Cuisine/template.json": [
		"08c5",
		"chunk-2d0a5130"
	],
	"./template10/Turkish Cuisine/template.json": [
		"a12d",
		"chunk-2d207758"
	],
	"./template10/Vegetarian/template.json": [
		"0c9b",
		"chunk-2d0aedb2"
	],
	"./template10/Waffles/template.json": [
		"cc1f",
		"chunk-2d221bab"
	],
	"./template10/juice bar/template.json": [
		"0e6f",
		"chunk-2d0af4db"
	],
	"./template11/American Cuisine/template.json": [
		"a7236",
		"chunk-76f12829"
	],
	"./template11/Balti/template.json": [
		"70f6",
		"chunk-2d0d621f"
	],
	"./template11/Bangladeshi Cuisine/template.json": [
		"cde4",
		"chunk-2d222586"
	],
	"./template11/Breakfast/template.json": [
		"7f93",
		"chunk-2d0e275f"
	],
	"./template11/British Cuisine/template.json": [
		"eef5",
		"chunk-2d231225"
	],
	"./template11/Burgers/template.json": [
		"4fa4",
		"chunk-2d0ccf1b"
	],
	"./template11/Café/template.json": [
		"a647",
		"chunk-2d208a2e"
	],
	"./template11/Cakes/template.json": [
		"f440",
		"chunk-2d22c880"
	],
	"./template11/Cantonese/template.json": [
		"c24f",
		"chunk-2d216417"
	],
	"./template11/Caribbean/template.json": [
		"dfbe",
		"chunk-2d22a13b"
	],
	"./template11/Chicken/template.json": [
		"b335",
		"chunk-2d20f329"
	],
	"./template11/Chinese/template.json": [
		"3ebb",
		"chunk-2d0c5748"
	],
	"./template11/Curry/template.json": [
		"4ff90",
		"chunk-748d27d5"
	],
	"./template11/Desserts/template.json": [
		"aa58",
		"chunk-2d212bb9"
	],
	"./template11/Doughnuts/template.json": [
		"d770",
		"chunk-2d21eb62"
	],
	"./template11/Fast Food/template.json": [
		"4cac",
		"chunk-2d0cc407"
	],
	"./template11/Fish and Chips/template.json": [
		"cadd",
		"chunk-2d221a54"
	],
	"./template11/Grill/template.json": [
		"7751",
		"chunk-2d0d7672"
	],
	"./template11/Healthy/template.json": [
		"f807",
		"chunk-2d22d70f"
	],
	"./template11/Indian Cuisine/template.json": [
		"71c9",
		"chunk-2d0d6586"
	],
	"./template11/Italian Cuisine/template.json": [
		"dae2",
		"chunk-2d228ea0"
	],
	"./template11/Kebab/template.json": [
		"68d6",
		"chunk-2d0d0b8a"
	],
	"./template11/Lunch/template.json": [
		"8c44",
		"chunk-2d0e8fe1"
	],
	"./template11/Middle Eastern Cuisine/template.json": [
		"b93d",
		"chunk-2d2109de"
	],
	"./template11/Milkshakes/template.json": [
		"2c6b",
		"chunk-2d0bd613"
	],
	"./template11/Noodles/template.json": [
		"b1cd",
		"chunk-2d20f1a6"
	],
	"./template11/Organic Food/template.json": [
		"5f17",
		"chunk-2d0d3dad"
	],
	"./template11/Oriental Cuisine/template.json": [
		"4ccf",
		"chunk-2d0cc448"
	],
	"./template11/Other/template.json": [
		"ed5c",
		"chunk-2d2308a3"
	],
	"./template11/Pakistani Cuisine/template.json": [
		"409b",
		"chunk-2d0bffbb"
	],
	"./template11/Pan Asian Restaurant/template.json": [
		"e8a2",
		"chunk-2d22689a"
	],
	"./template11/Peri-Peri/template.json": [
		"91bf",
		"chunk-2d0e4e52"
	],
	"./template11/Persian Cuisine/template.json": [
		"d358",
		"chunk-2d21dc28"
	],
	"./template11/Pizza/template.json": [
		"b612",
		"chunk-2d20fe2b"
	],
	"./template11/Portuguese Cuisine/template.json": [
		"879d",
		"chunk-2d0deb80"
	],
	"./template11/Roast Dinner/template.json": [
		"1fe0",
		"chunk-2d0b7276"
	],
	"./template11/Salads/template.json": [
		"a792",
		"chunk-2d208e85"
	],
	"./template11/Sandwiches/template.json": [
		"9552",
		"chunk-2d0e57af"
	],
	"./template11/Sea Food/template.json": [
		"0879",
		"chunk-2d0a4be0"
	],
	"./template11/Steak/template.json": [
		"683f",
		"chunk-2d0d05cb"
	],
	"./template11/Subways/template.json": [
		"9713",
		"chunk-2d0e5eb6"
	],
	"./template11/Sushi/template.json": [
		"3c73",
		"chunk-2d0c4a62"
	],
	"./template11/Thai Cuisine/template.json": [
		"daad",
		"chunk-2d228e56"
	],
	"./template11/Turkish Cuisine/template.json": [
		"4657",
		"chunk-2d0c159a"
	],
	"./template11/Vegetarian/template.json": [
		"91fd",
		"chunk-2d0e4ecc"
	],
	"./template11/Waffles/template.json": [
		"5f00",
		"chunk-2d0d3d87"
	],
	"./template11/juice bar/template.json": [
		"196f",
		"chunk-2d0ac40e"
	],
	"./template12/American Cuisine/template.json": [
		"193a",
		"chunk-2d0ac3ac"
	],
	"./template12/Balti/template.json": [
		"590a",
		"chunk-2d0c94cb"
	],
	"./template12/Bangladeshi Cuisine/template.json": [
		"e985",
		"chunk-2d226767"
	],
	"./template12/Breakfast/template.json": [
		"e6de",
		"chunk-2d2261a8"
	],
	"./template12/British Cuisine/template.json": [
		"b8fe",
		"chunk-2d210c4b"
	],
	"./template12/Burgers/template.json": [
		"f43b",
		"chunk-2d22c893"
	],
	"./template12/Café/template.json": [
		"4efc",
		"chunk-2d0ccc24"
	],
	"./template12/Cakes/template.json": [
		"a46a",
		"chunk-2d208314"
	],
	"./template12/Cantonese/template.json": [
		"85d3",
		"chunk-2d0de902"
	],
	"./template12/Caribbean/template.json": [
		"6a4c",
		"chunk-2d0d9fd0"
	],
	"./template12/Chicken/template.json": [
		"401c",
		"chunk-2d0bfec4"
	],
	"./template12/Chinese/template.json": [
		"e32d",
		"chunk-2d225056"
	],
	"./template12/Curry/template.json": [
		"ef98",
		"chunk-2d231076"
	],
	"./template12/Desserts/template.json": [
		"48d6",
		"chunk-2d0c22cc"
	],
	"./template12/Doughnuts/template.json": [
		"8a51",
		"chunk-2d0e887b"
	],
	"./template12/Fast Food/template.json": [
		"f8b3",
		"chunk-2d22dd19"
	],
	"./template12/Fish and Chips/template.json": [
		"798b",
		"chunk-2d0d7e82"
	],
	"./template12/Grill/template.json": [
		"a7b3",
		"chunk-2d20937d"
	],
	"./template12/Healthy/template.json": [
		"7d70",
		"chunk-2d0e1f9c"
	],
	"./template12/Indian Cuisine/template.json": [
		"1a5c",
		"chunk-2d0b5a14"
	],
	"./template12/Italian Cuisine/template.json": [
		"a941",
		"chunk-2d20956b"
	],
	"./template12/Kebab/template.json": [
		"943e",
		"chunk-2d0e53e3"
	],
	"./template12/Lunch/template.json": [
		"0158",
		"chunk-2d0a315a"
	],
	"./template12/Middle Eastern Cuisine/template.json": [
		"d5c5",
		"chunk-2d21e939"
	],
	"./template12/Milkshakes/template.json": [
		"fcc7",
		"chunk-2d237ea7"
	],
	"./template12/Noodles/template.json": [
		"2fed",
		"chunk-2d0be709"
	],
	"./template12/Organic Food/template.json": [
		"179c",
		"chunk-2d0abce6"
	],
	"./template12/Oriental Cuisine/template.json": [
		"3ed6",
		"chunk-2d0c575a"
	],
	"./template12/Other/template.json": [
		"0920",
		"chunk-2d0a4efd"
	],
	"./template12/Pakistani Cuisine/template.json": [
		"5bac",
		"chunk-2d0d34a5"
	],
	"./template12/Pan Asian Restaurant/template.json": [
		"776e",
		"chunk-2d0d76c5"
	],
	"./template12/Peri-Peri/template.json": [
		"db16",
		"chunk-2d228c19"
	],
	"./template12/Persian Cuisine/template.json": [
		"bfff",
		"chunk-2d21b8fa"
	],
	"./template12/Pizza/template.json": [
		"34f9",
		"chunk-2d0b9faa"
	],
	"./template12/Portuguese Cuisine/template.json": [
		"af52",
		"chunk-2d213e78"
	],
	"./template12/Roast Dinner/template.json": [
		"f630",
		"chunk-2d22cfe3"
	],
	"./template12/Salads/template.json": [
		"b4b2",
		"chunk-2d20fc98"
	],
	"./template12/Sandwiches/template.json": [
		"ca5a",
		"chunk-2d2214a0"
	],
	"./template12/Sea Food/template.json": [
		"cf94",
		"chunk-2d2227b4"
	],
	"./template12/Steak/template.json": [
		"bd04",
		"chunk-2d21aabc"
	],
	"./template12/Subways/template.json": [
		"6cc2",
		"chunk-2d0dacd2"
	],
	"./template12/Sushi/template.json": [
		"7ded",
		"chunk-2d0e2562"
	],
	"./template12/Thai Cuisine/template.json": [
		"0c2a",
		"chunk-2d0aecd8"
	],
	"./template12/Turkish Cuisine/template.json": [
		"ad54",
		"chunk-2d2136f8"
	],
	"./template12/Vegetarian/template.json": [
		"a8ba",
		"chunk-2d20976c"
	],
	"./template12/Waffles/template.json": [
		"2082",
		"chunk-2d0b16ae"
	],
	"./template12/juice bar/template.json": [
		"7341",
		"chunk-2d0d674f"
	],
	"./template13/American Cuisine/template.json": [
		"2c7f",
		"chunk-2d0bd636"
	],
	"./template13/Balti/template.json": [
		"15e6",
		"chunk-2d0aba8b"
	],
	"./template13/Bangladeshi Cuisine/template.json": [
		"3cad",
		"chunk-2d0c4fa9"
	],
	"./template13/Breakfast/template.json": [
		"1569",
		"chunk-2d0ab4dd"
	],
	"./template13/British Cuisine/template.json": [
		"1d22",
		"chunk-2d0b64c9"
	],
	"./template13/Burgers/template.json": [
		"cab3",
		"chunk-2d2219e5"
	],
	"./template13/Café/template.json": [
		"7c1c",
		"chunk-2d0e1b54"
	],
	"./template13/Cakes/template.json": [
		"2bd3",
		"chunk-2d0bd7b5"
	],
	"./template13/Cantonese/template.json": [
		"9060",
		"chunk-2d0e4507"
	],
	"./template13/Caribbean/template.json": [
		"b5ba",
		"chunk-2d210088"
	],
	"./template13/Chicken/template.json": [
		"5b75",
		"chunk-2d0d2f61"
	],
	"./template13/Chinese/template.json": [
		"4606",
		"chunk-2d0c14fe"
	],
	"./template13/Curry/template.json": [
		"e7de",
		"chunk-2d226569"
	],
	"./template13/Desserts/template.json": [
		"c0aa",
		"chunk-2d216203"
	],
	"./template13/Doughnuts/template.json": [
		"f992",
		"chunk-2d22dbe2"
	],
	"./template13/Fast Food/template.json": [
		"07af",
		"chunk-2d0a4d62"
	],
	"./template13/Fish and Chips/template.json": [
		"2486",
		"chunk-2d0b25b6"
	],
	"./template13/Grill/template.json": [
		"c7c5",
		"chunk-2d217c5c"
	],
	"./template13/Healthy/template.json": [
		"8054",
		"chunk-2d0dd08d"
	],
	"./template13/Indian Cuisine/template.json": [
		"9a9d",
		"chunk-2d0efd89"
	],
	"./template13/Italian Cuisine/template.json": [
		"dc34",
		"chunk-2d229016"
	],
	"./template13/Kebab/template.json": [
		"30dd",
		"chunk-2d0b9093"
	],
	"./template13/Lunch/template.json": [
		"c166",
		"chunk-2d216064"
	],
	"./template13/Middle Eastern Cuisine/template.json": [
		"858b",
		"chunk-2d0de3dd"
	],
	"./template13/Milkshakes/template.json": [
		"bdfc",
		"chunk-2d21b175"
	],
	"./template13/Noodles/template.json": [
		"2cf6",
		"chunk-2d0bdbb7"
	],
	"./template13/Organic Food/template.json": [
		"1dee",
		"chunk-2d0b6b29"
	],
	"./template13/Oriental Cuisine/template.json": [
		"7705",
		"chunk-2d0d75db"
	],
	"./template13/Other/template.json": [
		"6b51",
		"chunk-2d0da37e"
	],
	"./template13/Pakistani Cuisine/template.json": [
		"ccba",
		"chunk-2d222195"
	],
	"./template13/Pan Asian Restaurant/template.json": [
		"5e88",
		"chunk-2d0d3ac6"
	],
	"./template13/Peri-Peri/template.json": [
		"cf71",
		"chunk-2d222773"
	],
	"./template13/Persian Cuisine/template.json": [
		"c06a",
		"chunk-2d215cce"
	],
	"./template13/Pizza/template.json": [
		"1db3",
		"chunk-2d0b6a9a"
	],
	"./template13/Portuguese Cuisine/template.json": [
		"c177",
		"chunk-2d216084"
	],
	"./template13/Roast Dinner/template.json": [
		"351d",
		"chunk-2d0b9d2b"
	],
	"./template13/Salads/template.json": [
		"9c79",
		"chunk-2d0f04a2"
	],
	"./template13/Sandwiches/template.json": [
		"1b76",
		"chunk-2d0b5de6"
	],
	"./template13/Sea Food/template.json": [
		"cf34",
		"chunk-2d2226fa"
	],
	"./template13/Steak/template.json": [
		"d7c7",
		"chunk-2d21f0bd"
	],
	"./template13/Subways/template.json": [
		"98ca",
		"chunk-2d0e68b3"
	],
	"./template13/Sushi/template.json": [
		"4c45",
		"chunk-2d0cbe66"
	],
	"./template13/Thai Cuisine/template.json": [
		"7c49",
		"chunk-2d0e1b87"
	],
	"./template13/Turkish Cuisine/template.json": [
		"6706",
		"chunk-2d0d017d"
	],
	"./template13/Vegetarian/template.json": [
		"5c95",
		"chunk-2d0d3360"
	],
	"./template13/Waffles/template.json": [
		"f5b6",
		"chunk-2d22d1d9"
	],
	"./template13/juice bar/template.json": [
		"18f1",
		"chunk-2d0ac5e8"
	],
	"./template14/American Cuisine/template.json": [
		"2183",
		"chunk-2d0b1a70"
	],
	"./template14/Balti/template.json": [
		"3de1",
		"chunk-2d0c53b3"
	],
	"./template14/Bangladeshi Cuisine/template.json": [
		"5139",
		"chunk-2d0c76f8"
	],
	"./template14/Breakfast/template.json": [
		"99d8",
		"chunk-2d0e6c6a"
	],
	"./template14/British Cuisine/template.json": [
		"9377",
		"chunk-2d0e5070"
	],
	"./template14/Burgers/template.json": [
		"4955",
		"chunk-2d0c20db"
	],
	"./template14/Café/template.json": [
		"2711",
		"chunk-2d0b301b"
	],
	"./template14/Cakes/template.json": [
		"4b07",
		"chunk-2d0cba2b"
	],
	"./template14/Cantonese/template.json": [
		"4227",
		"chunk-2d0c0639"
	],
	"./template14/Caribbean/template.json": [
		"546f",
		"chunk-2d0c82c5"
	],
	"./template14/Chicken/template.json": [
		"60b0",
		"chunk-2d0ced3e"
	],
	"./template14/Chinese/template.json": [
		"038e",
		"chunk-2d0a3966"
	],
	"./template14/Curry/template.json": [
		"77bb",
		"chunk-2d0d7c16"
	],
	"./template14/Desserts/template.json": [
		"01bf",
		"chunk-2d0a36fb"
	],
	"./template14/Doughnuts/template.json": [
		"0ac9",
		"chunk-2d0aeb1d"
	],
	"./template14/Fast Food/template.json": [
		"4393",
		"chunk-2d0c0acf"
	],
	"./template14/Fish and Chips/template.json": [
		"63bd",
		"chunk-2d0cf8b5"
	],
	"./template14/Grill/template.json": [
		"52b9",
		"chunk-2d0c806a"
	],
	"./template14/Healthy/template.json": [
		"b15a",
		"chunk-2d20ec11"
	],
	"./template14/Indian Cuisine/template.json": [
		"d111",
		"chunk-2d21d423"
	],
	"./template14/Italian Cuisine/template.json": [
		"f272",
		"chunk-2d22c15d"
	],
	"./template14/Kebab/template.json": [
		"6382",
		"chunk-2d0cf36d"
	],
	"./template14/Lunch/template.json": [
		"29a2",
		"chunk-2d0b3d6e"
	],
	"./template14/Middle Eastern Cuisine/template.json": [
		"b629",
		"chunk-2d20fe51"
	],
	"./template14/Milkshakes/template.json": [
		"276a",
		"chunk-2d0b30e6"
	],
	"./template14/Noodles/template.json": [
		"897e",
		"chunk-2d0df2c5"
	],
	"./template14/Organic Food/template.json": [
		"4e0d",
		"chunk-2d0cc59b"
	],
	"./template14/Oriental Cuisine/template.json": [
		"3c7b",
		"chunk-2d0c4a91"
	],
	"./template14/Other/template.json": [
		"1ed2",
		"chunk-2d0b6e98"
	],
	"./template14/Pakistani Cuisine/template.json": [
		"ad5c",
		"chunk-2d213727"
	],
	"./template14/Pan Asian Restaurant/template.json": [
		"efe1",
		"chunk-2d2315c3"
	],
	"./template14/Peri-Peri/template.json": [
		"c7c1",
		"chunk-2d217c58"
	],
	"./template14/Persian Cuisine/template.json": [
		"7940",
		"chunk-2d0d7dd4"
	],
	"./template14/Pizza/template.json": [
		"97a7",
		"chunk-2d0e648a"
	],
	"./template14/Portuguese Cuisine/template.json": [
		"0de0",
		"chunk-2d0af695"
	],
	"./template14/Roast Dinner/template.json": [
		"36e8",
		"chunk-2d0ba70c"
	],
	"./template14/Salads/template.json": [
		"f317",
		"chunk-2d22c469"
	],
	"./template14/Sandwiches/template.json": [
		"07b4",
		"chunk-2d0a4d4f"
	],
	"./template14/Sea Food/template.json": [
		"4417",
		"chunk-2d0c0d9c"
	],
	"./template14/Steak/template.json": [
		"8235",
		"chunk-2d0dd7d2"
	],
	"./template14/Subways/template.json": [
		"ca6e",
		"chunk-2d2214c3"
	],
	"./template14/Sushi/template.json": [
		"97a4",
		"chunk-2d0e6487"
	],
	"./template14/Thai Cuisine/template.json": [
		"a331",
		"chunk-2d207ec6"
	],
	"./template14/Turkish Cuisine/template.json": [
		"2b99",
		"chunk-2d0bd286"
	],
	"./template14/Vegetarian/template.json": [
		"a184",
		"chunk-2d2077e2"
	],
	"./template14/Waffles/template.json": [
		"e4ea",
		"chunk-2d225a41"
	],
	"./template14/juice bar/template.json": [
		"0b2c",
		"chunk-2d0ae919"
	],
	"./template15/American Cuisine/template.json": [
		"af78",
		"chunk-2d213ebc"
	],
	"./template15/Balti/template.json": [
		"8b72",
		"chunk-2d0e8c7b"
	],
	"./template15/Bangladeshi Cuisine/template.json": [
		"2742",
		"chunk-2d0b3079"
	],
	"./template15/Breakfast/template.json": [
		"2d2a",
		"chunk-2d0bd957"
	],
	"./template15/British Cuisine/template.json": [
		"c80e",
		"chunk-2d217a20"
	],
	"./template15/Burgers/template.json": [
		"68e4",
		"chunk-2d0d0ba7"
	],
	"./template15/Café/template.json": [
		"a555",
		"chunk-2d20868a"
	],
	"./template15/Cakes/template.json": [
		"4a66",
		"chunk-2d0cb723"
	],
	"./template15/Cantonese/template.json": [
		"f2c6",
		"chunk-2d22c6b5"
	],
	"./template15/Caribbean/template.json": [
		"688e",
		"chunk-2d0d0665"
	],
	"./template15/Chicken/template.json": [
		"8896",
		"chunk-2d0def13"
	],
	"./template15/Chinese/template.json": [
		"6f8d",
		"chunk-2d0db312"
	],
	"./template15/Curry/template.json": [
		"e12e",
		"chunk-2d2248d5"
	],
	"./template15/Desserts/template.json": [
		"97fc",
		"chunk-2d0e6551"
	],
	"./template15/Doughnuts/template.json": [
		"5505",
		"chunk-2d0c859b"
	],
	"./template15/Fast Food/template.json": [
		"5e57",
		"chunk-2d0d3a68"
	],
	"./template15/Fish and Chips/template.json": [
		"da62",
		"chunk-2d2288ef"
	],
	"./template15/Grill/template.json": [
		"41ec",
		"chunk-2d0c08d1"
	],
	"./template15/Healthy/template.json": [
		"a50d",
		"chunk-2d20861e"
	],
	"./template15/Indian Cuisine/template.json": [
		"f44e",
		"chunk-2d22c8b5"
	],
	"./template15/Italian Cuisine/template.json": [
		"57b3",
		"chunk-2d0c9329"
	],
	"./template15/Kebab/template.json": [
		"8550",
		"chunk-2d0de34e"
	],
	"./template15/Lunch/template.json": [
		"eee7",
		"chunk-2d231208"
	],
	"./template15/Middle Eastern Cuisine/template.json": [
		"c9c5",
		"chunk-2d2183de"
	],
	"./template15/Milkshakes/template.json": [
		"ace8",
		"chunk-2d21390b"
	],
	"./template15/Noodles/template.json": [
		"64bd",
		"chunk-2d0cfc76"
	],
	"./template15/Organic Food/template.json": [
		"c806",
		"chunk-2d2179f1"
	],
	"./template15/Oriental Cuisine/template.json": [
		"d9c6",
		"chunk-2d21f83e"
	],
	"./template15/Other/template.json": [
		"46a7",
		"chunk-2d0c1aee"
	],
	"./template15/Pakistani Cuisine/template.json": [
		"f7fb",
		"chunk-2d22da03"
	],
	"./template15/Pan Asian Restaurant/template.json": [
		"3e19",
		"chunk-2d0c5130"
	],
	"./template15/Peri-Peri/template.json": [
		"a608",
		"chunk-2d2089b3"
	],
	"./template15/Persian Cuisine/template.json": [
		"98ba6",
		"chunk-74beaa22"
	],
	"./template15/Pizza/template.json": [
		"4a7f",
		"chunk-2d0cb772"
	],
	"./template15/Portuguese Cuisine/template.json": [
		"c181",
		"chunk-2d21609d"
	],
	"./template15/Roast Dinner/template.json": [
		"d1bf",
		"chunk-2d21da47"
	],
	"./template15/Salads/template.json": [
		"874c",
		"chunk-2d0deae4"
	],
	"./template15/Sandwiches/template.json": [
		"c76f",
		"chunk-2d21771a"
	],
	"./template15/Sea Food/template.json": [
		"6950",
		"chunk-2d0d0994"
	],
	"./template15/Steak/template.json": [
		"1bbb",
		"chunk-2d0b6347"
	],
	"./template15/Subways/template.json": [
		"ecbf",
		"chunk-2d230a58"
	],
	"./template15/Sushi/template.json": [
		"1a62",
		"chunk-2d0b5a02"
	],
	"./template15/Thai Cuisine/template.json": [
		"919b",
		"chunk-2d0e4957"
	],
	"./template15/Turkish Cuisine/template.json": [
		"d2fd",
		"chunk-2d21de82"
	],
	"./template15/Vegetarian/template.json": [
		"8567",
		"chunk-2d0de374"
	],
	"./template15/Waffles/template.json": [
		"1d79",
		"chunk-2d0b656b"
	],
	"./template15/juice bar/template.json": [
		"6a2c",
		"chunk-2d0d9f92"
	],
	"./template16/American Cuisine/template.json": [
		"6b49",
		"chunk-2d0da367"
	],
	"./template16/Balti/template.json": [
		"d9a6",
		"chunk-2d21f800"
	],
	"./template16/Bangladeshi Cuisine/template.json": [
		"019b",
		"chunk-2d0a3200"
	],
	"./template16/Breakfast/template.json": [
		"6fb5",
		"chunk-2d0db7f9"
	],
	"./template16/British Cuisine/template.json": [
		"080b",
		"chunk-2d0a4b30"
	],
	"./template16/Burgers/template.json": [
		"3744",
		"chunk-2d0ba4da"
	],
	"./template16/Café/template.json": [
		"ed21",
		"chunk-2d230814"
	],
	"./template16/Cakes/template.json": [
		"23c9",
		"chunk-2d0b272d"
	],
	"./template16/Cantonese/template.json": [
		"c770",
		"chunk-2d217703"
	],
	"./template16/Caribbean/template.json": [
		"6b32",
		"chunk-2d0da341"
	],
	"./template16/Chicken/template.json": [
		"4a81",
		"chunk-2d0cb75c"
	],
	"./template16/Chinese/template.json": [
		"206d",
		"chunk-2d0b16a2"
	],
	"./template16/Curry/template.json": [
		"92a2",
		"chunk-2d0e51c0"
	],
	"./template16/Desserts/template.json": [
		"bc79",
		"chunk-2d21a7d9"
	],
	"./template16/Doughnuts/template.json": [
		"4eb1",
		"chunk-2d0ccb76"
	],
	"./template16/Fast Food/template.json": [
		"6ab4",
		"chunk-2d0da533"
	],
	"./template16/Fish and Chips/template.json": [
		"cfcc",
		"chunk-2d222cf9"
	],
	"./template16/Grill/template.json": [
		"fabb",
		"chunk-2d237731"
	],
	"./template16/Healthy/template.json": [
		"7b6a",
		"chunk-2d0e182c"
	],
	"./template16/Indian Cuisine/template.json": [
		"ef5b",
		"chunk-2d231024"
	],
	"./template16/Italian Cuisine/template.json": [
		"02a0",
		"chunk-2d0a3a67"
	],
	"./template16/Kebab/template.json": [
		"1323",
		"chunk-2d0aacd9"
	],
	"./template16/Lunch/template.json": [
		"2765",
		"chunk-2d0b30ba"
	],
	"./template16/Middle Eastern Cuisine/template.json": [
		"292b",
		"chunk-2d0b37ed"
	],
	"./template16/Milkshakes/template.json": [
		"31bb",
		"chunk-2d0b9414"
	],
	"./template16/Noodles/template.json": [
		"ebbd",
		"chunk-2d230695"
	],
	"./template16/Organic Food/template.json": [
		"64a3",
		"chunk-2d0cfc26"
	],
	"./template16/Oriental Cuisine/template.json": [
		"e6a0",
		"chunk-2d226116"
	],
	"./template16/Other/template.json": [
		"7ce3",
		"chunk-2d0e2170"
	],
	"./template16/Pakistani Cuisine/template.json": [
		"2570",
		"chunk-2d0b2952"
	],
	"./template16/Pan Asian Restaurant/template.json": [
		"9a0b",
		"chunk-2d0efc70"
	],
	"./template16/Peri-Peri/template.json": [
		"c5ee",
		"chunk-2d217548"
	],
	"./template16/Persian Cuisine/template.json": [
		"bc1b",
		"chunk-2d21a748"
	],
	"./template16/Pizza/template.json": [
		"11a1",
		"chunk-2d0aab06"
	],
	"./template16/Portuguese Cuisine/template.json": [
		"4fd1",
		"chunk-2d0ccf75"
	],
	"./template16/Roast Dinner/template.json": [
		"8604",
		"chunk-2d0de678"
	],
	"./template16/Salads/template.json": [
		"a70ee",
		"chunk-76f126e4"
	],
	"./template16/Sandwiches/template.json": [
		"b966",
		"chunk-2d210a0d"
	],
	"./template16/Sea Food/template.json": [
		"f06c",
		"chunk-2d22b9ed"
	],
	"./template16/Steak/template.json": [
		"739a",
		"chunk-2d0d681a"
	],
	"./template16/Subways/template.json": [
		"9707",
		"chunk-2d0e5e9b"
	],
	"./template16/Sushi/template.json": [
		"8fe7",
		"chunk-2d0ea116"
	],
	"./template16/Thai Cuisine/template.json": [
		"781b",
		"chunk-2d0d79e8"
	],
	"./template16/Turkish Cuisine/template.json": [
		"18d8",
		"chunk-2d0ac5b1"
	],
	"./template16/Vegetarian/template.json": [
		"6889",
		"chunk-2d0d0639"
	],
	"./template16/Waffles/template.json": [
		"306a",
		"chunk-2d0b8afe"
	],
	"./template16/juice bar/template.json": [
		"cc208",
		"chunk-77215724"
	],
	"./template17/American Cuisine/template.json": [
		"2959",
		"chunk-2d0b3821"
	],
	"./template17/Balti/template.json": [
		"d807",
		"chunk-2d21ee51"
	],
	"./template17/Bangladeshi Cuisine/template.json": [
		"ed2e",
		"chunk-2d230848"
	],
	"./template17/Breakfast/template.json": [
		"6248",
		"chunk-2d0cef36"
	],
	"./template17/British Cuisine/template.json": [
		"d63b",
		"chunk-2d21e757"
	],
	"./template17/Burgers/template.json": [
		"11a0",
		"chunk-2d0aab05"
	],
	"./template17/Café/template.json": [
		"5df1",
		"chunk-2d0d3c90"
	],
	"./template17/Cakes/template.json": [
		"2593",
		"chunk-2d0b2993"
	],
	"./template17/Cantonese/template.json": [
		"a074",
		"chunk-2d207402"
	],
	"./template17/Caribbean/template.json": [
		"461d",
		"chunk-2d0c154b"
	],
	"./template17/Chicken/template.json": [
		"ff16",
		"chunk-2d2383db"
	],
	"./template17/Chinese/template.json": [
		"f28c",
		"chunk-2d22c1ad"
	],
	"./template17/Curry/template.json": [
		"00d5",
		"chunk-2d0a3347"
	],
	"./template17/Desserts/template.json": [
		"dad0",
		"chunk-2d228e7f"
	],
	"./template17/Doughnuts/template.json": [
		"c0e9",
		"chunk-2d216257"
	],
	"./template17/Fast Food/template.json": [
		"be42",
		"chunk-2d21aef7"
	],
	"./template17/Fish and Chips/template.json": [
		"ca9b",
		"chunk-2d22151d"
	],
	"./template17/Grill/template.json": [
		"95ad",
		"chunk-2d0e5d35"
	],
	"./template17/Healthy/template.json": [
		"40f4",
		"chunk-2d0c0500"
	],
	"./template17/Indian Cuisine/template.json": [
		"4790",
		"chunk-2d0c19d0"
	],
	"./template17/Italian Cuisine/template.json": [
		"2fbe",
		"chunk-2d0be6ad"
	],
	"./template17/Kebab/template.json": [
		"e7e0",
		"chunk-2d226553"
	],
	"./template17/Lunch/template.json": [
		"b4e3",
		"chunk-2d20fcf6"
	],
	"./template17/Middle Eastern Cuisine/template.json": [
		"5edb",
		"chunk-2d0d4044"
	],
	"./template17/Milkshakes/template.json": [
		"f2d6",
		"chunk-2d22c6d4"
	],
	"./template17/Noodles/template.json": [
		"092d",
		"chunk-2d0a4f31"
	],
	"./template17/Organic Food/template.json": [
		"3ce9",
		"chunk-2d0c4ffa"
	],
	"./template17/Oriental Cuisine/template.json": [
		"4252",
		"chunk-2d0c0691"
	],
	"./template17/Other/template.json": [
		"78b7",
		"chunk-2d0d7fac"
	],
	"./template17/Pakistani Cuisine/template.json": [
		"c725",
		"chunk-2d21766d"
	],
	"./template17/Pan Asian Restaurant/template.json": [
		"388d",
		"chunk-2d0ba947"
	],
	"./template17/Peri-Peri/template.json": [
		"fdef",
		"chunk-2d2382d5"
	],
	"./template17/Persian Cuisine/template.json": [
		"32a0",
		"chunk-2d0b9784"
	],
	"./template17/Pizza/template.json": [
		"8b70",
		"chunk-2d0e8c79"
	],
	"./template17/Portuguese Cuisine/template.json": [
		"875d",
		"chunk-2d0deb04"
	],
	"./template17/Roast Dinner/template.json": [
		"eb74",
		"chunk-2d230130"
	],
	"./template17/Salads/template.json": [
		"8ca6",
		"chunk-2d0e9556"
	],
	"./template17/Sandwiches/template.json": [
		"f35c",
		"chunk-2d22c511"
	],
	"./template17/Sea Food/template.json": [
		"9b05",
		"chunk-2d0f0004"
	],
	"./template17/Steak/template.json": [
		"64c9",
		"chunk-2d0cfc6a"
	],
	"./template17/Subways/template.json": [
		"97a5",
		"chunk-2d0e6488"
	],
	"./template17/Sushi/template.json": [
		"f6bb",
		"chunk-2d22d5c6"
	],
	"./template17/Thai Cuisine/template.json": [
		"0ccba",
		"chunk-74536699"
	],
	"./template17/Turkish Cuisine/template.json": [
		"c96c",
		"chunk-2d217e99"
	],
	"./template17/Vegetarian/template.json": [
		"d546",
		"chunk-2d21e389"
	],
	"./template17/Waffles/template.json": [
		"18b7",
		"chunk-2d0ac572"
	],
	"./template17/juice bar/template.json": [
		"1574",
		"chunk-2d0ab4f7"
	],
	"./template18/American Cuisine/template.json": [
		"743d",
		"chunk-2d0d6b24"
	],
	"./template18/Balti/template.json": [
		"282b",
		"chunk-2d0b342c"
	],
	"./template18/Bangladeshi Cuisine/template.json": [
		"d738",
		"chunk-2d21eaee"
	],
	"./template18/Breakfast/template.json": [
		"604f",
		"chunk-2d0ce7e2"
	],
	"./template18/British Cuisine/template.json": [
		"6e8e",
		"chunk-2d0daf52"
	],
	"./template18/Burgers/template.json": [
		"0ca6",
		"chunk-2d0af25e"
	],
	"./template18/Café/template.json": [
		"8ee2",
		"chunk-2d0e9d50"
	],
	"./template18/Cakes/template.json": [
		"d849",
		"chunk-2d21eecf"
	],
	"./template18/Cantonese/template.json": [
		"cd8d",
		"chunk-2d222043"
	],
	"./template18/Caribbean/template.json": [
		"bc3c",
		"chunk-2d21a787"
	],
	"./template18/Chicken/template.json": [
		"467fd",
		"chunk-7476ab3d"
	],
	"./template18/Chinese/template.json": [
		"88a7f",
		"chunk-74b089fa"
	],
	"./template18/Curry/template.json": [
		"13b6",
		"chunk-2d0ab2ac"
	],
	"./template18/Desserts/template.json": [
		"ba86",
		"chunk-2d21a073"
	],
	"./template18/Doughnuts/template.json": [
		"2895",
		"chunk-2d0b34d8"
	],
	"./template18/Fast Food/template.json": [
		"25a0",
		"chunk-2d0b2e68"
	],
	"./template18/Fish and Chips/template.json": [
		"dbfe",
		"chunk-2d2292b3"
	],
	"./template18/Grill/template.json": [
		"69f5",
		"chunk-2d0d0f88"
	],
	"./template18/Healthy/template.json": [
		"66de",
		"chunk-2d0d0437"
	],
	"./template18/Indian Cuisine/template.json": [
		"9fba",
		"chunk-2d0f1542"
	],
	"./template18/Italian Cuisine/template.json": [
		"a20b",
		"chunk-2d207ad9"
	],
	"./template18/Kebab/template.json": [
		"fc96",
		"chunk-2d237990"
	],
	"./template18/Lunch/template.json": [
		"9bca",
		"chunk-2d0f065d"
	],
	"./template18/Middle Eastern Cuisine/template.json": [
		"4993",
		"chunk-2d0c2155"
	],
	"./template18/Milkshakes/template.json": [
		"c95f",
		"chunk-2d217e7d"
	],
	"./template18/Noodles/template.json": [
		"884e",
		"chunk-2d0deea7"
	],
	"./template18/Organic Food/template.json": [
		"9e4e",
		"chunk-2d0f0bf3"
	],
	"./template18/Oriental Cuisine/template.json": [
		"fc3a",
		"chunk-2d237901"
	],
	"./template18/Other/template.json": [
		"767a",
		"chunk-2d0d731f"
	],
	"./template18/Pakistani Cuisine/template.json": [
		"4d76",
		"chunk-2d0cc285"
	],
	"./template18/Pan Asian Restaurant/template.json": [
		"0216",
		"chunk-2d0a349d"
	],
	"./template18/Peri-Peri/template.json": [
		"4108",
		"chunk-2d0c023b"
	],
	"./template18/Persian Cuisine/template.json": [
		"b83a",
		"chunk-2d21061a"
	],
	"./template18/Pizza/template.json": [
		"7e1d",
		"chunk-2d0e22d7"
	],
	"./template18/Portuguese Cuisine/template.json": [
		"3a2b",
		"chunk-2d0c4274"
	],
	"./template18/Roast Dinner/template.json": [
		"6e0d",
		"chunk-2d0dae59"
	],
	"./template18/Salads/template.json": [
		"a139",
		"chunk-2d20774c"
	],
	"./template18/Sandwiches/template.json": [
		"128e",
		"chunk-2d0aaa04"
	],
	"./template18/Sea Food/template.json": [
		"1181",
		"chunk-2d0aa60f"
	],
	"./template18/Steak/template.json": [
		"4598",
		"chunk-2d0c1256"
	],
	"./template18/Subways/template.json": [
		"7701",
		"chunk-2d0d75d7"
	],
	"./template18/Sushi/template.json": [
		"d316",
		"chunk-2d21dbaa"
	],
	"./template18/Thai Cuisine/template.json": [
		"31c3",
		"chunk-2d0b9404"
	],
	"./template18/Turkish Cuisine/template.json": [
		"e4d2",
		"chunk-2d2259f3"
	],
	"./template18/Vegetarian/template.json": [
		"93c4",
		"chunk-2d0e55c1"
	],
	"./template18/Waffles/template.json": [
		"4cc8",
		"chunk-2d0cc41a"
	],
	"./template18/juice bar/template.json": [
		"ef41",
		"chunk-2d230fd4"
	],
	"./template19/American Cuisine/template.json": [
		"67b1",
		"chunk-2d0d0786"
	],
	"./template19/Balti/template.json": [
		"ed09",
		"chunk-2d2307de"
	],
	"./template19/Bangladeshi Cuisine/template.json": [
		"bd8e",
		"chunk-2d21abe5"
	],
	"./template19/Breakfast/template.json": [
		"67e1",
		"chunk-2d0d07e3"
	],
	"./template19/British Cuisine/template.json": [
		"f351",
		"chunk-2d22c4df"
	],
	"./template19/Burgers/template.json": [
		"941f",
		"chunk-2d0e53a6"
	],
	"./template19/Café/template.json": [
		"bcfb",
		"chunk-2d21adb3"
	],
	"./template19/Cakes/template.json": [
		"a3d9",
		"chunk-2d2084bd"
	],
	"./template19/Cantonese/template.json": [
		"352c",
		"chunk-2d0b9d49"
	],
	"./template19/Caribbean/template.json": [
		"8544",
		"chunk-2d0de333"
	],
	"./template19/Chicken/template.json": [
		"1303",
		"chunk-2d0aac9b"
	],
	"./template19/Chinese/template.json": [
		"5d47",
		"chunk-2d0d3688"
	],
	"./template19/Curry/template.json": [
		"be39",
		"chunk-2d21aedf"
	],
	"./template19/Desserts/template.json": [
		"acf3",
		"chunk-2d213925"
	],
	"./template19/Doughnuts/template.json": [
		"6dab",
		"chunk-2d0db085"
	],
	"./template19/Fast Food/template.json": [
		"03a9",
		"chunk-2d0a3e31"
	],
	"./template19/Fish and Chips/template.json": [
		"a113",
		"chunk-2d207708"
	],
	"./template19/Grill/template.json": [
		"e7f2",
		"chunk-2d226574"
	],
	"./template19/Healthy/template.json": [
		"900d",
		"chunk-2d0e4481"
	],
	"./template19/Indian Cuisine/template.json": [
		"803b",
		"chunk-2d0dd07d"
	],
	"./template19/Italian Cuisine/template.json": [
		"5ff6",
		"chunk-2d0d4417"
	],
	"./template19/Kebab/template.json": [
		"c0c2",
		"chunk-2d216212"
	],
	"./template19/Lunch/template.json": [
		"6480",
		"chunk-2d0cf72c"
	],
	"./template19/Middle Eastern Cuisine/template.json": [
		"dc8f",
		"chunk-2d2290e3"
	],
	"./template19/Milkshakes/template.json": [
		"29e3",
		"chunk-2d0b3deb"
	],
	"./template19/Noodles/template.json": [
		"f6c3",
		"chunk-2d22d5b6"
	],
	"./template19/Organic Food/template.json": [
		"7df3",
		"chunk-2d0e2550"
	],
	"./template19/Oriental Cuisine/template.json": [
		"94b5",
		"chunk-2d0e5964"
	],
	"./template19/Other/template.json": [
		"f2a7",
		"chunk-2d22c678"
	],
	"./template19/Pakistani Cuisine/template.json": [
		"b933",
		"chunk-2d2109ad"
	],
	"./template19/Pan Asian Restaurant/template.json": [
		"c512",
		"chunk-2d216ec9"
	],
	"./template19/Peri-Peri/template.json": [
		"70c4",
		"chunk-2d0d61c0"
	],
	"./template19/Persian Cuisine/template.json": [
		"5b5e",
		"chunk-2d0d2f53"
	],
	"./template19/Pizza/template.json": [
		"45f4",
		"chunk-2d0c17c5"
	],
	"./template19/Portuguese Cuisine/template.json": [
		"131a3",
		"chunk-744af04b"
	],
	"./template19/Roast Dinner/template.json": [
		"cdd9",
		"chunk-2d22256c"
	],
	"./template19/Salads/template.json": [
		"e71c",
		"chunk-2d225f3a"
	],
	"./template19/Sandwiches/template.json": [
		"3c71",
		"chunk-2d0c4a60"
	],
	"./template19/Sea Food/template.json": [
		"92fc",
		"chunk-2d0e528c"
	],
	"./template19/Steak/template.json": [
		"d6f6",
		"chunk-2d21ed58"
	],
	"./template19/Subways/template.json": [
		"5216",
		"chunk-2d0c7a78"
	],
	"./template19/Sushi/template.json": [
		"55cd",
		"chunk-2d0c8bf7"
	],
	"./template19/Thai Cuisine/template.json": [
		"5f73",
		"chunk-2d0d3e63"
	],
	"./template19/Turkish Cuisine/template.json": [
		"eaef",
		"chunk-2d230333"
	],
	"./template19/Vegetarian/template.json": [
		"7e98",
		"chunk-2d0e23a3"
	],
	"./template19/Waffles/template.json": [
		"2317",
		"chunk-2d0b211d"
	],
	"./template19/juice bar/template.json": [
		"364b",
		"chunk-2d0ba147"
	],
	"./template2/American Cuisine/template.json": [
		"051b",
		"chunk-2d0a400c"
	],
	"./template2/Balti/template.json": [
		"3b49",
		"chunk-2d0c464a"
	],
	"./template2/Bangladeshi Cuisine/template.json": [
		"8f67",
		"chunk-2d0e9b65"
	],
	"./template2/Breakfast/template.json": [
		"91b8",
		"chunk-2d0e4e24"
	],
	"./template2/British Cuisine/template.json": [
		"e008",
		"chunk-2d2244a9"
	],
	"./template2/Burgers/template.json": [
		"d22c",
		"chunk-2d21d835"
	],
	"./template2/Café/template.json": [
		"9b5d",
		"chunk-2d0f00ce"
	],
	"./template2/Cakes/template.json": [
		"4ab8",
		"chunk-2d0cbc79"
	],
	"./template2/Cantonese/template.json": [
		"4535",
		"chunk-2d0c1199"
	],
	"./template2/Caribbean/template.json": [
		"56ec",
		"chunk-2d0c8ff5"
	],
	"./template2/Chicken/template.json": [
		"33ca",
		"chunk-2d0b9bb4"
	],
	"./template2/Chinese/template.json": [
		"9c4c",
		"chunk-2d0f046f"
	],
	"./template2/Curry/template.json": [
		"8a8e",
		"chunk-2d0e890c"
	],
	"./template2/Desserts/template.json": [
		"cccc",
		"chunk-2d2221b6"
	],
	"./template2/Doughnuts/template.json": [
		"612b",
		"chunk-2d0ceb61"
	],
	"./template2/Fast Food/template.json": [
		"b031",
		"chunk-2d20e7e2"
	],
	"./template2/Fish and Chips/template.json": [
		"1b78",
		"chunk-2d0b5de8"
	],
	"./template2/Grill/template.json": [
		"5ad6",
		"chunk-2d0d3114"
	],
	"./template2/Healthy/template.json": [
		"de27",
		"chunk-2d22977c"
	],
	"./template2/Indian Cuisine/template.json": [
		"ef43",
		"chunk-2d230fd6"
	],
	"./template2/Italian Cuisine/template.json": [
		"a8f3",
		"chunk-2d2097ba"
	],
	"./template2/Kebab/template.json": [
		"55e8",
		"chunk-2d0c8c09"
	],
	"./template2/Lunch/template.json": [
		"572c",
		"chunk-2d0c8d89"
	],
	"./template2/Middle Eastern Cuisine/template.json": [
		"dab4",
		"chunk-2d228e45"
	],
	"./template2/Milkshakes/template.json": [
		"a678",
		"chunk-2d208a8c"
	],
	"./template2/Noodles/template.json": [
		"a15f",
		"chunk-2d2077b7"
	],
	"./template2/Organic Food/template.json": [
		"6386",
		"chunk-2d0cf371"
	],
	"./template2/Oriental Cuisine/template.json": [
		"7b11",
		"chunk-2d0e1761"
	],
	"./template2/Other/template.json": [
		"d1f8",
		"chunk-2d21da95"
	],
	"./template2/Pakistani Cuisine/template.json": [
		"8be8",
		"chunk-2d0e9213"
	],
	"./template2/Pan Asian Restaurant/template.json": [
		"7709",
		"chunk-2d0d75df"
	],
	"./template2/Peri-Peri/template.json": [
		"3258",
		"chunk-2d0b9238"
	],
	"./template2/Persian Cuisine/template.json": [
		"d65e",
		"chunk-2d21e798"
	],
	"./template2/Pizza/template.json": [
		"0eb7",
		"chunk-2d0afa00"
	],
	"./template2/Portuguese Cuisine/template.json": [
		"2eb7",
		"chunk-2d0be2be"
	],
	"./template2/Roast Dinner/template.json": [
		"68ca",
		"chunk-2d0d0b96"
	],
	"./template2/Salads/template.json": [
		"8b66",
		"chunk-2d0e8c60"
	],
	"./template2/Sandwiches/template.json": [
		"d8f1",
		"chunk-2d21f4d5"
	],
	"./template2/Sea Food/template.json": [
		"e6f5",
		"chunk-2d2261b6"
	],
	"./template2/Steak/template.json": [
		"c8bf",
		"chunk-2d21802f"
	],
	"./template2/Subways/template.json": [
		"0635",
		"chunk-2d0a43de"
	],
	"./template2/Sushi/template.json": [
		"4b177",
		"chunk-748a8f2d"
	],
	"./template2/Thai Cuisine/template.json": [
		"ee83",
		"chunk-2d230c91"
	],
	"./template2/Turkish Cuisine/template.json": [
		"f4a5",
		"chunk-2d22cdf8"
	],
	"./template2/Vegetarian/template.json": [
		"2d38",
		"chunk-2d0bd94d"
	],
	"./template2/Waffles/template.json": [
		"f12d",
		"chunk-2d22bd33"
	],
	"./template2/juice bar/template.json": [
		"f32d",
		"chunk-2d22c4b5"
	],
	"./template20/American Cuisine/template.json": [
		"7e81",
		"chunk-2d0e237d"
	],
	"./template20/Balti/template.json": [
		"968a",
		"chunk-2d0e5bfc"
	],
	"./template20/Bangladeshi Cuisine/template.json": [
		"0583",
		"chunk-2d0a40b6"
	],
	"./template20/Breakfast/template.json": [
		"9b57",
		"chunk-2d0f00a1"
	],
	"./template20/British Cuisine/template.json": [
		"e378",
		"chunk-2d2250c5"
	],
	"./template20/Burgers/template.json": [
		"1f90",
		"chunk-2d0b6d22"
	],
	"./template20/Café/template.json": [
		"ce69",
		"chunk-2d22239b"
	],
	"./template20/Cakes/template.json": [
		"aff8",
		"chunk-2d21446d"
	],
	"./template20/Cantonese/template.json": [
		"b7aec",
		"chunk-76fff654"
	],
	"./template20/Caribbean/template.json": [
		"9ab9",
		"chunk-2d0f0255"
	],
	"./template20/Chicken/template.json": [
		"856b",
		"chunk-2d0de39f"
	],
	"./template20/Chinese/template.json": [
		"6001",
		"chunk-2d0ce731"
	],
	"./template20/Curry/template.json": [
		"143a",
		"chunk-2d0ab0e7"
	],
	"./template20/Desserts/template.json": [
		"149f",
		"chunk-2d0ab1a6"
	],
	"./template20/Doughnuts/template.json": [
		"2d2f",
		"chunk-2d0bd95c"
	],
	"./template20/Fast Food/template.json": [
		"e56f",
		"chunk-2d225856"
	],
	"./template20/Fish and Chips/template.json": [
		"47ad",
		"chunk-2d0c1edc"
	],
	"./template20/Grill/template.json": [
		"0a10",
		"chunk-2d0ae506"
	],
	"./template20/Healthy/template.json": [
		"a3bd",
		"chunk-2d2084aa"
	],
	"./template20/Indian Cuisine/template.json": [
		"e54f",
		"chunk-2d225818"
	],
	"./template20/Italian Cuisine/template.json": [
		"da8c",
		"chunk-2d22895e"
	],
	"./template20/Kebab/template.json": [
		"3ead",
		"chunk-2d0c572b"
	],
	"./template20/Lunch/template.json": [
		"ff25",
		"chunk-2d2383f9"
	],
	"./template20/Middle Eastern Cuisine/template.json": [
		"12cf",
		"chunk-2d0aaf3a"
	],
	"./template20/Milkshakes/template.json": [
		"f012",
		"chunk-2d22b921"
	],
	"./template20/Noodles/template.json": [
		"b771",
		"chunk-2d2102a5"
	],
	"./template20/Organic Food/template.json": [
		"d7a8",
		"chunk-2d21f080"
	],
	"./template20/Oriental Cuisine/template.json": [
		"74df",
		"chunk-2d0d7115"
	],
	"./template20/Other/template.json": [
		"830b",
		"chunk-2d0ddb63"
	],
	"./template20/Pakistani Cuisine/template.json": [
		"7816",
		"chunk-2d0d79bc"
	],
	"./template20/Pan Asian Restaurant/template.json": [
		"2c9e",
		"chunk-2d0bd673"
	],
	"./template20/Peri-Peri/template.json": [
		"9d4b",
		"chunk-2d0f082f"
	],
	"./template20/Persian Cuisine/template.json": [
		"62dc",
		"chunk-2d0cf531"
	],
	"./template20/Pizza/template.json": [
		"24a9",
		"chunk-2d0b2ab0"
	],
	"./template20/Portuguese Cuisine/template.json": [
		"6f95",
		"chunk-2d0db302"
	],
	"./template20/Roast Dinner/template.json": [
		"ff39",
		"chunk-2d23841c"
	],
	"./template20/Salads/template.json": [
		"ce1a",
		"chunk-2d222328"
	],
	"./template20/Sandwiches/template.json": [
		"2796",
		"chunk-2d0b3118"
	],
	"./template20/Sea Food/template.json": [
		"047d",
		"chunk-2d0a3d07"
	],
	"./template20/Steak/template.json": [
		"2946",
		"chunk-2d0b37ff"
	],
	"./template20/Subways/template.json": [
		"94bf",
		"chunk-2d0e5995"
	],
	"./template20/Sushi/template.json": [
		"2034",
		"chunk-2d0b1615"
	],
	"./template20/Thai Cuisine/template.json": [
		"3461",
		"chunk-2d0b99d2"
	],
	"./template20/Turkish Cuisine/template.json": [
		"e264",
		"chunk-2d224ce1"
	],
	"./template20/Vegetarian/template.json": [
		"4935",
		"chunk-2d0c209d"
	],
	"./template20/Waffles/template.json": [
		"f675",
		"chunk-2d22d064"
	],
	"./template20/juice bar/template.json": [
		"f2bb",
		"chunk-2d22c6c2"
	],
	"./template3/American Cuisine/template.json": [
		"7330",
		"chunk-2d0d672f"
	],
	"./template3/Balti/template.json": [
		"5247",
		"chunk-2d0c7ad6"
	],
	"./template3/Bangladeshi Cuisine/template.json": [
		"9a14",
		"chunk-2d0efc61"
	],
	"./template3/Breakfast/template.json": [
		"ed0e",
		"chunk-2d23080a"
	],
	"./template3/British Cuisine/template.json": [
		"f6db",
		"chunk-2d22d604"
	],
	"./template3/Burgers/template.json": [
		"a706",
		"chunk-2d208d72"
	],
	"./template3/Café/template.json": [
		"76eb",
		"chunk-2d0d78b2"
	],
	"./template3/Cakes/template.json": [
		"27d4",
		"chunk-2d0b364b"
	],
	"./template3/Cantonese/template.json": [
		"8b0e",
		"chunk-2d0e8bd5"
	],
	"./template3/Caribbean/template.json": [
		"d580",
		"chunk-2d21e3ff"
	],
	"./template3/Chicken/template.json": [
		"a355",
		"chunk-2d207f08"
	],
	"./template3/Chinese/template.json": [
		"f592",
		"chunk-2d22ccde"
	],
	"./template3/Curry/template.json": [
		"1d3d",
		"chunk-2d0b651a"
	],
	"./template3/Desserts/template.json": [
		"865f",
		"chunk-2d0de745"
	],
	"./template3/Doughnuts/template.json": [
		"e072",
		"chunk-2d22457c"
	],
	"./template3/Fast Food/template.json": [
		"bbec",
		"chunk-2d21a9d4"
	],
	"./template3/Fish and Chips/template.json": [
		"33b8",
		"chunk-2d0b9b6c"
	],
	"./template3/Grill/template.json": [
		"61b7",
		"chunk-2d0cf106"
	],
	"./template3/Healthy/template.json": [
		"fff80",
		"chunk-774dbee8"
	],
	"./template3/Indian Cuisine/template.json": [
		"5161",
		"chunk-2d0c774d"
	],
	"./template3/Italian Cuisine/template.json": [
		"d9c7",
		"chunk-2d21f83f"
	],
	"./template3/Kebab/template.json": [
		"2eae",
		"chunk-2d0be2cd"
	],
	"./template3/Lunch/template.json": [
		"c56a",
		"chunk-2d216f93"
	],
	"./template3/Middle Eastern Cuisine/template.json": [
		"0f24",
		"chunk-2d0af7ee"
	],
	"./template3/Milkshakes/template.json": [
		"0d31",
		"chunk-2d0af088"
	],
	"./template3/Noodles/template.json": [
		"9ff1",
		"chunk-2d0f158e"
	],
	"./template3/Organic Food/template.json": [
		"4dca",
		"chunk-2d0cc804"
	],
	"./template3/Oriental Cuisine/template.json": [
		"1bf8",
		"chunk-2d0b6399"
	],
	"./template3/Other/template.json": [
		"2208",
		"chunk-2d0b1d3e"
	],
	"./template3/Pakistani Cuisine/template.json": [
		"3e5f",
		"chunk-2d0c51d9"
	],
	"./template3/Pan Asian Restaurant/template.json": [
		"12d4",
		"chunk-2d0aaf27"
	],
	"./template3/Peri-Peri/template.json": [
		"cc5e",
		"chunk-2d221c26"
	],
	"./template3/Persian Cuisine/template.json": [
		"9d5e",
		"chunk-2d0f0851"
	],
	"./template3/Pizza/template.json": [
		"808b",
		"chunk-2d0dd118"
	],
	"./template3/Portuguese Cuisine/template.json": [
		"9a17",
		"chunk-2d0efc64"
	],
	"./template3/Roast Dinner/template.json": [
		"0166",
		"chunk-2d0a3177"
	],
	"./template3/Salads/template.json": [
		"8a6e",
		"chunk-2d0e88ce"
	],
	"./template3/Sandwiches/template.json": [
		"fabf",
		"chunk-2d237735"
	],
	"./template3/Sea Food/template.json": [
		"d9e8",
		"chunk-2d21f87e"
	],
	"./template3/Steak/template.json": [
		"61be",
		"chunk-2d0cf134"
	],
	"./template3/Subways/template.json": [
		"be77",
		"chunk-2d21af59"
	],
	"./template3/Sushi/template.json": [
		"b885",
		"chunk-2d210689"
	],
	"./template3/Thai Cuisine/template.json": [
		"6598",
		"chunk-2d0cfb14"
	],
	"./template3/Turkish Cuisine/template.json": [
		"b6a5",
		"chunk-2d2103fe"
	],
	"./template3/Vegetarian/template.json": [
		"8719",
		"chunk-2d0dea5d"
	],
	"./template3/Waffles/template.json": [
		"ec4d",
		"chunk-2d2304c4"
	],
	"./template3/juice bar/template.json": [
		"3e4d",
		"chunk-2d0c51b8"
	],
	"./template4/American Cuisine/template.json": [
		"fee0",
		"chunk-2d238660"
	],
	"./template4/Balti/template.json": [
		"0303",
		"chunk-2d0a383c"
	],
	"./template4/Bangladeshi Cuisine/template.json": [
		"43b4",
		"chunk-2d0c0fc7"
	],
	"./template4/Breakfast/template.json": [
		"3ead7",
		"chunk-747e8e6c"
	],
	"./template4/British Cuisine/template.json": [
		"95a4",
		"chunk-2d0e5d05"
	],
	"./template4/Burgers/template.json": [
		"80c4",
		"chunk-2d0dd61f"
	],
	"./template4/Café/template.json": [
		"6e55",
		"chunk-2d0daec5"
	],
	"./template4/Cakes/template.json": [
		"2511",
		"chunk-2d0b2899"
	],
	"./template4/Cantonese/template.json": [
		"67eb",
		"chunk-2d0d0814"
	],
	"./template4/Caribbean/template.json": [
		"d863",
		"chunk-2d21ef07"
	],
	"./template4/Chicken/template.json": [
		"6715",
		"chunk-2d0d019b"
	],
	"./template4/Chinese/template.json": [
		"d2f3",
		"chunk-2d21de51"
	],
	"./template4/Curry/template.json": [
		"2d7f",
		"chunk-2d0bd9f7"
	],
	"./template4/Desserts/template.json": [
		"301c",
		"chunk-2d0b8a65"
	],
	"./template4/Doughnuts/template.json": [
		"4f18",
		"chunk-2d0cc94f"
	],
	"./template4/Fast Food/template.json": [
		"cb86",
		"chunk-2d221893"
	],
	"./template4/Fish and Chips/template.json": [
		"bbcc",
		"chunk-2d21a996"
	],
	"./template4/Grill/template.json": [
		"d678",
		"chunk-2d21e7a9"
	],
	"./template4/Healthy/template.json": [
		"85c5",
		"chunk-2d0de8e5"
	],
	"./template4/Indian Cuisine/template.json": [
		"a81b",
		"chunk-2d20917e"
	],
	"./template4/Italian Cuisine/template.json": [
		"bf7a",
		"chunk-2d21b344"
	],
	"./template4/Kebab/template.json": [
		"1902",
		"chunk-2d0ac320"
	],
	"./template4/Lunch/template.json": [
		"726f",
		"chunk-2d0d6401"
	],
	"./template4/Middle Eastern Cuisine/template.json": [
		"e4fc",
		"chunk-2d225a62"
	],
	"./template4/Milkshakes/template.json": [
		"ba28",
		"chunk-2d219fbb"
	],
	"./template4/Noodles/template.json": [
		"6b6a",
		"chunk-2d0da3cd"
	],
	"./template4/Organic Food/template.json": [
		"7170",
		"chunk-2d0d6029"
	],
	"./template4/Oriental Cuisine/template.json": [
		"aadb",
		"chunk-2d213194"
	],
	"./template4/Other/template.json": [
		"b01c",
		"chunk-2d20e7d6"
	],
	"./template4/Pakistani Cuisine/template.json": [
		"1fbc",
		"chunk-2d0b724c"
	],
	"./template4/Pan Asian Restaurant/template.json": [
		"af87",
		"chunk-2d213eda"
	],
	"./template4/Peri-Peri/template.json": [
		"1319",
		"chunk-2d0aacc0"
	],
	"./template4/Persian Cuisine/template.json": [
		"20a7",
		"chunk-2d0b1baa"
	],
	"./template4/Pizza/template.json": [
		"3190",
		"chunk-2d0b8eeb"
	],
	"./template4/Portuguese Cuisine/template.json": [
		"afaf",
		"chunk-2d214400"
	],
	"./template4/Roast Dinner/template.json": [
		"8d1a",
		"chunk-2d0e9372"
	],
	"./template4/Salads/template.json": [
		"b609",
		"chunk-2d20fe13"
	],
	"./template4/Sandwiches/template.json": [
		"7dba7",
		"chunk-74b67b75"
	],
	"./template4/Sea Food/template.json": [
		"439e",
		"chunk-2d0c0b01"
	],
	"./template4/Steak/template.json": [
		"4b11",
		"chunk-2d0cba44"
	],
	"./template4/Subways/template.json": [
		"d367",
		"chunk-2d21dc46"
	],
	"./template4/Sushi/template.json": [
		"7fbb",
		"chunk-2d0e2c85"
	],
	"./template4/Thai Cuisine/template.json": [
		"adc7",
		"chunk-2d213c8d"
	],
	"./template4/Turkish Cuisine/template.json": [
		"dd8c",
		"chunk-2d2294a1"
	],
	"./template4/Vegetarian/template.json": [
		"11b7",
		"chunk-2d0aab2b"
	],
	"./template4/Waffles/template.json": [
		"2b78",
		"chunk-2d0bd247"
	],
	"./template4/juice bar/template.json": [
		"0e8f",
		"chunk-2d0af519"
	],
	"./template5/American Cuisine/template.json": [
		"e0c6",
		"chunk-2d224ad4"
	],
	"./template5/Balti/template.json": [
		"4fea",
		"chunk-2d0ccfc4"
	],
	"./template5/Bangladeshi Cuisine/template.json": [
		"a365",
		"chunk-2d207f27"
	],
	"./template5/Breakfast/template.json": [
		"9b64",
		"chunk-2d0f00bd"
	],
	"./template5/British Cuisine/template.json": [
		"17806",
		"chunk-744cd622"
	],
	"./template5/Burgers/template.json": [
		"5b7e",
		"chunk-2d0d2f91"
	],
	"./template5/Café/template.json": [
		"8e69",
		"chunk-2d0e97a6"
	],
	"./template5/Cakes/template.json": [
		"0d97",
		"chunk-2d0af148"
	],
	"./template5/Cantonese/template.json": [
		"6cfa",
		"chunk-2d0dad5e"
	],
	"./template5/Caribbean/template.json": [
		"e4ef",
		"chunk-2d225a46"
	],
	"./template5/Chicken/template.json": [
		"ba26",
		"chunk-2d219fb9"
	],
	"./template5/Chinese/template.json": [
		"337a",
		"chunk-2d0b9660"
	],
	"./template5/Curry/template.json": [
		"e9eb",
		"chunk-2d226d07"
	],
	"./template5/Desserts/template.json": [
		"c2f7",
		"chunk-2d2169f6"
	],
	"./template5/Doughnuts/template.json": [
		"2fa8",
		"chunk-2d0be661"
	],
	"./template5/Fast Food/template.json": [
		"608f",
		"chunk-2d0ce85e"
	],
	"./template5/Fish and Chips/template.json": [
		"fe73",
		"chunk-2d2380d1"
	],
	"./template5/Grill/template.json": [
		"0aae",
		"chunk-2d0aeb0b"
	],
	"./template5/Healthy/template.json": [
		"b4d1",
		"chunk-2d20fcd5"
	],
	"./template5/Indian Cuisine/template.json": [
		"9206",
		"chunk-2d0e4bd5"
	],
	"./template5/Italian Cuisine/template.json": [
		"8663",
		"chunk-2d0de731"
	],
	"./template5/Kebab/template.json": [
		"cf6d",
		"chunk-2d222787"
	],
	"./template5/Lunch/template.json": [
		"145d",
		"chunk-2d0ab128"
	],
	"./template5/Middle Eastern Cuisine/template.json": [
		"3868",
		"chunk-2d0ba8dd"
	],
	"./template5/Milkshakes/template.json": [
		"d3fb",
		"chunk-2d21e241"
	],
	"./template5/Noodles/template.json": [
		"f4e3",
		"chunk-2d22ce72"
	],
	"./template5/Organic Food/template.json": [
		"45a5",
		"chunk-2d0c172b"
	],
	"./template5/Oriental Cuisine/template.json": [
		"058f",
		"chunk-2d0a40e9"
	],
	"./template5/Other/template.json": [
		"0f19",
		"chunk-2d0af7d4"
	],
	"./template5/Pakistani Cuisine/template.json": [
		"241a",
		"chunk-2d0b2508"
	],
	"./template5/Pan Asian Restaurant/template.json": [
		"7c1e",
		"chunk-2d0e1b56"
	],
	"./template5/Peri-Peri/template.json": [
		"5cf6",
		"chunk-2d0d38d4"
	],
	"./template5/Persian Cuisine/template.json": [
		"be60",
		"chunk-2d21af33"
	],
	"./template5/Pizza/template.json": [
		"565c",
		"chunk-2d0c8a25"
	],
	"./template5/Portuguese Cuisine/template.json": [
		"9f2e",
		"chunk-2d0f0f76"
	],
	"./template5/Roast Dinner/template.json": [
		"70c8",
		"chunk-2d0d61c4"
	],
	"./template5/Salads/template.json": [
		"0f97",
		"chunk-2d0af8ca"
	],
	"./template5/Sandwiches/template.json": [
		"bc3f",
		"chunk-2d21a78a"
	],
	"./template5/Sea Food/template.json": [
		"0d0b",
		"chunk-2d0af05c"
	],
	"./template5/Steak/template.json": [
		"e180",
		"chunk-2d22495a"
	],
	"./template5/Subways/template.json": [
		"cd24",
		"chunk-2d221f59"
	],
	"./template5/Sushi/template.json": [
		"78fb",
		"chunk-2d0d8053"
	],
	"./template5/Thai Cuisine/template.json": [
		"ee4b",
		"chunk-2d230c44"
	],
	"./template5/Turkish Cuisine/template.json": [
		"655f",
		"chunk-2d0cfac6"
	],
	"./template5/Vegetarian/template.json": [
		"9e93",
		"chunk-2d0f0c5c"
	],
	"./template5/Waffles/template.json": [
		"dcfc",
		"chunk-2d229672"
	],
	"./template5/juice bar/template.json": [
		"bb31",
		"chunk-2d21a394"
	],
	"./template6/American Cuisine/template.json": [
		"53c4",
		"chunk-2d0c8445"
	],
	"./template6/Balti/template.json": [
		"92ce",
		"chunk-2d0e5231"
	],
	"./template6/Bangladeshi Cuisine/template.json": [
		"4a5f",
		"chunk-2d0cb734"
	],
	"./template6/Breakfast/template.json": [
		"22f6",
		"chunk-2d0b23c6"
	],
	"./template6/British Cuisine/template.json": [
		"7632",
		"chunk-2d0d7274"
	],
	"./template6/Burgers/template.json": [
		"9412",
		"chunk-2d0e5372"
	],
	"./template6/Café/template.json": [
		"f805",
		"chunk-2d22d70d"
	],
	"./template6/Cakes/template.json": [
		"e558",
		"chunk-2d225809"
	],
	"./template6/Cantonese/template.json": [
		"7dfc",
		"chunk-2d0e2580"
	],
	"./template6/Caribbean/template.json": [
		"d631",
		"chunk-2d21e726"
	],
	"./template6/Chicken/template.json": [
		"f874",
		"chunk-2d22d7e5"
	],
	"./template6/Chinese/template.json": [
		"bf3d",
		"chunk-2d21b2cb"
	],
	"./template6/Curry/template.json": [
		"fac5",
		"chunk-2d237723"
	],
	"./template6/Desserts/template.json": [
		"a1dd",
		"chunk-2d207d66"
	],
	"./template6/Doughnuts/template.json": [
		"57c5",
		"chunk-2d0c934a"
	],
	"./template6/Fast Food/template.json": [
		"461c",
		"chunk-2d0c154a"
	],
	"./template6/Fish and Chips/template.json": [
		"81fc",
		"chunk-2d0dda6c"
	],
	"./template6/Grill/template.json": [
		"765a",
		"chunk-2d0d72e1"
	],
	"./template6/Healthy/template.json": [
		"3f56",
		"chunk-2d0c556a"
	],
	"./template6/Indian Cuisine/template.json": [
		"e442",
		"chunk-2d225423"
	],
	"./template6/Italian Cuisine/template.json": [
		"9a35",
		"chunk-2d0efca0"
	],
	"./template6/Kebab/template.json": [
		"2318",
		"chunk-2d0b211e"
	],
	"./template6/Lunch/template.json": [
		"8d93",
		"chunk-2d0e943c"
	],
	"./template6/Middle Eastern Cuisine/template.json": [
		"00aa",
		"chunk-2d0a3316"
	],
	"./template6/Milkshakes/template.json": [
		"988e",
		"chunk-2d0e6382"
	],
	"./template6/Noodles/template.json": [
		"6e65",
		"chunk-2d0daee4"
	],
	"./template6/Organic Food/template.json": [
		"4ca6",
		"chunk-2d0cc3da"
	],
	"./template6/Oriental Cuisine/template.json": [
		"df9c",
		"chunk-2d229c42"
	],
	"./template6/Other/template.json": [
		"2844",
		"chunk-2d0b343c"
	],
	"./template6/Pakistani Cuisine/template.json": [
		"c06c",
		"chunk-2d215cd0"
	],
	"./template6/Pan Asian Restaurant/template.json": [
		"4e08",
		"chunk-2d0cc56f"
	],
	"./template6/Peri-Peri/template.json": [
		"ef3d",
		"chunk-2d230fe8"
	],
	"./template6/Persian Cuisine/template.json": [
		"6b30",
		"chunk-2d0da33f"
	],
	"./template6/Pizza/template.json": [
		"5d21",
		"chunk-2d0d3644"
	],
	"./template6/Portuguese Cuisine/template.json": [
		"9c14",
		"chunk-2d0f03e3"
	],
	"./template6/Roast Dinner/template.json": [
		"7083",
		"chunk-2d0d5c8a"
	],
	"./template6/Salads/template.json": [
		"d8a9",
		"chunk-2d21f442"
	],
	"./template6/Sandwiches/template.json": [
		"f046",
		"chunk-2d22b982"
	],
	"./template6/Sea Food/template.json": [
		"e2c2",
		"chunk-2d225252"
	],
	"./template6/Steak/template.json": [
		"fbc7",
		"chunk-2d237ae6"
	],
	"./template6/Subways/template.json": [
		"71fc",
		"chunk-2d0d660d"
	],
	"./template6/Sushi/template.json": [
		"199c",
		"chunk-2d0ac468"
	],
	"./template6/Thai Cuisine/template.json": [
		"b18c",
		"chunk-2d20ec70"
	],
	"./template6/Turkish Cuisine/template.json": [
		"dd31",
		"chunk-2d2293d4"
	],
	"./template6/Vegetarian/template.json": [
		"7d9a",
		"chunk-2d0e200b"
	],
	"./template6/Waffles/template.json": [
		"c504",
		"chunk-2d216eac"
	],
	"./template6/juice bar/template.json": [
		"51aa",
		"chunk-2d0c7cb2"
	],
	"./template7/American Cuisine/template.json": [
		"c3da",
		"chunk-2d216da3"
	],
	"./template7/Balti/template.json": [
		"3834",
		"chunk-2d0ba87c"
	],
	"./template7/Bangladeshi Cuisine/template.json": [
		"c876",
		"chunk-2d217aca"
	],
	"./template7/Breakfast/template.json": [
		"12b9",
		"chunk-2d0aaeee"
	],
	"./template7/British Cuisine/template.json": [
		"be91",
		"chunk-2d21af91"
	],
	"./template7/Burgers/template.json": [
		"5b63",
		"chunk-2d0d2f40"
	],
	"./template7/Café/template.json": [
		"b964",
		"chunk-2d210a0b"
	],
	"./template7/Cakes/template.json": [
		"ed08",
		"chunk-2d2307dd"
	],
	"./template7/Cantonese/template.json": [
		"9426",
		"chunk-2d0e5395"
	],
	"./template7/Caribbean/template.json": [
		"40f3",
		"chunk-2d0c04ff"
	],
	"./template7/Chicken/template.json": [
		"2118",
		"chunk-2d0b199c"
	],
	"./template7/Chinese/template.json": [
		"0dfc",
		"chunk-2d0af6e7"
	],
	"./template7/Curry/template.json": [
		"127f",
		"chunk-2d0aa9e6"
	],
	"./template7/Desserts/template.json": [
		"cf73",
		"chunk-2d222775"
	],
	"./template7/Doughnuts/template.json": [
		"d62d",
		"chunk-2d21e73a"
	],
	"./template7/Fast Food/template.json": [
		"5f28",
		"chunk-2d0d3dcd"
	],
	"./template7/Fish and Chips/template.json": [
		"666a",
		"chunk-2d0cfea1"
	],
	"./template7/Grill/template.json": [
		"6e73",
		"chunk-2d0daf01"
	],
	"./template7/Healthy/template.json": [
		"f864",
		"chunk-2d22d7c6"
	],
	"./template7/Indian Cuisine/template.json": [
		"f45b",
		"chunk-2d22c8d1"
	],
	"./template7/Italian Cuisine/template.json": [
		"68d8",
		"chunk-2d0d0b8c"
	],
	"./template7/Kebab/template.json": [
		"d408",
		"chunk-2d21df4e"
	],
	"./template7/Lunch/template.json": [
		"def7",
		"chunk-2d229dc8"
	],
	"./template7/Middle Eastern Cuisine/template.json": [
		"cac6",
		"chunk-2d221a07"
	],
	"./template7/Milkshakes/template.json": [
		"7b8f",
		"chunk-2d0e186f"
	],
	"./template7/Noodles/template.json": [
		"04dd",
		"chunk-2d0a427a"
	],
	"./template7/Organic Food/template.json": [
		"4f66",
		"chunk-2d0cc9e8"
	],
	"./template7/Oriental Cuisine/template.json": [
		"72ed",
		"chunk-2d0d69b0"
	],
	"./template7/Other/template.json": [
		"06bb",
		"chunk-2d0a49bc"
	],
	"./template7/Pakistani Cuisine/template.json": [
		"f038",
		"chunk-2d22b965"
	],
	"./template7/Pan Asian Restaurant/template.json": [
		"4815",
		"chunk-2d0c1c9e"
	],
	"./template7/Peri-Peri/template.json": [
		"7d0d",
		"chunk-2d0e1ef7"
	],
	"./template7/Persian Cuisine/template.json": [
		"dc5d",
		"chunk-2d229084"
	],
	"./template7/Pizza/template.json": [
		"6925",
		"chunk-2d0d093c"
	],
	"./template7/Portuguese Cuisine/template.json": [
		"9ef2",
		"chunk-2d0f11ce"
	],
	"./template7/Roast Dinner/template.json": [
		"7a6a",
		"chunk-2d0e146b"
	],
	"./template7/Salads/template.json": [
		"237f",
		"chunk-2d0b2206"
	],
	"./template7/Sandwiches/template.json": [
		"59eb",
		"chunk-2d0c9b37"
	],
	"./template7/Sea Food/template.json": [
		"df56",
		"chunk-2d229b99"
	],
	"./template7/Steak/template.json": [
		"d8ba",
		"chunk-2d21f489"
	],
	"./template7/Subways/template.json": [
		"be37",
		"chunk-2d21aedd"
	],
	"./template7/Sushi/template.json": [
		"0b51",
		"chunk-2d0ae944"
	],
	"./template7/Thai Cuisine/template.json": [
		"db77",
		"chunk-2d228cd4"
	],
	"./template7/Turkish Cuisine/template.json": [
		"229f4",
		"chunk-7458b211"
	],
	"./template7/Vegetarian/template.json": [
		"567d",
		"chunk-2d0c8a64"
	],
	"./template7/Waffles/template.json": [
		"875b",
		"chunk-2d0deb02"
	],
	"./template7/juice bar/template.json": [
		"0baa",
		"chunk-2d0aeec8"
	],
	"./template8/American Cuisine/template.json": [
		"ac52",
		"chunk-2d213335"
	],
	"./template8/Balti/template.json": [
		"022c",
		"chunk-2d0a34e9"
	],
	"./template8/Bangladeshi Cuisine/template.json": [
		"5239",
		"chunk-2d0c7ab9"
	],
	"./template8/Breakfast/template.json": [
		"b7a9",
		"chunk-2d2107c3"
	],
	"./template8/British Cuisine/template.json": [
		"cc1c",
		"chunk-2d221ba8"
	],
	"./template8/Burgers/template.json": [
		"42b2",
		"chunk-2d0c0c04"
	],
	"./template8/Café/template.json": [
		"51616",
		"chunk-74827289"
	],
	"./template8/Cakes/template.json": [
		"f7bf",
		"chunk-2d22d98b"
	],
	"./template8/Cantonese/template.json": [
		"d870",
		"chunk-2d21ef23"
	],
	"./template8/Caribbean/template.json": [
		"fece",
		"chunk-2d238657"
	],
	"./template8/Chicken/template.json": [
		"277d",
		"chunk-2d0b3108"
	],
	"./template8/Chinese/template.json": [
		"f790",
		"chunk-2d22d45e"
	],
	"./template8/Curry/template.json": [
		"50125",
		"chunk-7481eb83"
	],
	"./template8/Desserts/template.json": [
		"eca0",
		"chunk-2d230a03"
	],
	"./template8/Doughnuts/template.json": [
		"1046",
		"chunk-2d0aa1d7"
	],
	"./template8/Fast Food/template.json": [
		"3486",
		"chunk-2d0b9a15"
	],
	"./template8/Fish and Chips/template.json": [
		"7f42",
		"chunk-2d0e26c3"
	],
	"./template8/Grill/template.json": [
		"87bb",
		"chunk-2d0df075"
	],
	"./template8/Healthy/template.json": [
		"b03a",
		"chunk-2d20e812"
	],
	"./template8/Indian Cuisine/template.json": [
		"f95a",
		"chunk-2d22db95"
	],
	"./template8/Italian Cuisine/template.json": [
		"a4347",
		"chunk-76efceed"
	],
	"./template8/Kebab/template.json": [
		"eab5",
		"chunk-2d2302a5"
	],
	"./template8/Lunch/template.json": [
		"387f3",
		"chunk-74697c49"
	],
	"./template8/Middle Eastern Cuisine/template.json": [
		"1c8a",
		"chunk-2d0b61f1"
	],
	"./template8/Milkshakes/template.json": [
		"7133",
		"chunk-2d0d5fb0"
	],
	"./template8/Noodles/template.json": [
		"4b22",
		"chunk-2d0cba64"
	],
	"./template8/Organic Food/template.json": [
		"6243",
		"chunk-2d0cef31"
	],
	"./template8/Oriental Cuisine/template.json": [
		"5ad6f",
		"chunk-7498f1d2"
	],
	"./template8/Other/template.json": [
		"c71e",
		"chunk-2d21767e"
	],
	"./template8/Pakistani Cuisine/template.json": [
		"c195",
		"chunk-2d2160c0"
	],
	"./template8/Pan Asian Restaurant/template.json": [
		"289b",
		"chunk-2d0b3505"
	],
	"./template8/Peri-Peri/template.json": [
		"31cd",
		"chunk-2d0b9435"
	],
	"./template8/Persian Cuisine/template.json": [
		"e78e",
		"chunk-2d226015"
	],
	"./template8/Pizza/template.json": [
		"8f35",
		"chunk-2d0e9b06"
	],
	"./template8/Portuguese Cuisine/template.json": [
		"2e79",
		"chunk-2d0bdd8b"
	],
	"./template8/Roast Dinner/template.json": [
		"a416",
		"chunk-2d20824e"
	],
	"./template8/Salads/template.json": [
		"a1a4",
		"chunk-2d207cd9"
	],
	"./template8/Sandwiches/template.json": [
		"6eef",
		"chunk-2d0db4c6"
	],
	"./template8/Sea Food/template.json": [
		"1274",
		"chunk-2d0aa9b4"
	],
	"./template8/Steak/template.json": [
		"3b71",
		"chunk-2d0c469f"
	],
	"./template8/Subways/template.json": [
		"f70d",
		"chunk-2d22d37b"
	],
	"./template8/Sushi/template.json": [
		"6949",
		"chunk-2d0d097e"
	],
	"./template8/Thai Cuisine/template.json": [
		"02be",
		"chunk-2d0a3abb"
	],
	"./template8/Turkish Cuisine/template.json": [
		"c6ec",
		"chunk-2d217907"
	],
	"./template8/Vegetarian/template.json": [
		"3687",
		"chunk-2d0ba198"
	],
	"./template8/Waffles/template.json": [
		"090a",
		"chunk-2d0a4ef0"
	],
	"./template8/juice bar/template.json": [
		"a858",
		"chunk-2d2091d0"
	],
	"./template9/American Cuisine/template.json": [
		"f4c5",
		"chunk-2d22ce36"
	],
	"./template9/Balti/template.json": [
		"19ab",
		"chunk-2d0ac93f"
	],
	"./template9/Bangladeshi Cuisine/template.json": [
		"4712",
		"chunk-2d0c18da"
	],
	"./template9/Breakfast/template.json": [
		"c0d1",
		"chunk-2d216230"
	],
	"./template9/British Cuisine/template.json": [
		"0117",
		"chunk-2d0a30dd"
	],
	"./template9/Burgers/template.json": [
		"1b48",
		"chunk-2d0b5d8b"
	],
	"./template9/Café/template.json": [
		"ef53",
		"chunk-2d230ff5"
	],
	"./template9/Cakes/template.json": [
		"82f4",
		"chunk-2d0dddfe"
	],
	"./template9/Cantonese/template.json": [
		"700f",
		"chunk-2d0d5bc5"
	],
	"./template9/Caribbean/template.json": [
		"4ec4",
		"chunk-2d0ccb98"
	],
	"./template9/Chicken/template.json": [
		"3f3e",
		"chunk-2d0c555b"
	],
	"./template9/Chinese/template.json": [
		"50bc",
		"chunk-2d0c7912"
	],
	"./template9/Curry/template.json": [
		"6d67",
		"chunk-2d0dab25"
	],
	"./template9/Desserts/template.json": [
		"2502",
		"chunk-2d0b287b"
	],
	"./template9/Doughnuts/template.json": [
		"fae2",
		"chunk-2d23775e"
	],
	"./template9/Fast Food/template.json": [
		"9709",
		"chunk-2d0e5e9d"
	],
	"./template9/Fish and Chips/template.json": [
		"7f10",
		"chunk-2d0e2664"
	],
	"./template9/Grill/template.json": [
		"300d",
		"chunk-2d0b8a47"
	],
	"./template9/Healthy/template.json": [
		"db43",
		"chunk-2d228c73"
	],
	"./template9/Indian Cuisine/template.json": [
		"7df0",
		"chunk-2d0e254d"
	],
	"./template9/Italian Cuisine/template.json": [
		"7b80",
		"chunk-2d0e1839"
	],
	"./template9/Kebab/template.json": [
		"0b77",
		"chunk-2d0ae988"
	],
	"./template9/Lunch/template.json": [
		"40be",
		"chunk-2d0c04b5"
	],
	"./template9/Middle Eastern Cuisine/template.json": [
		"e68d",
		"chunk-2d225c53"
	],
	"./template9/Milkshakes/template.json": [
		"927d",
		"chunk-2d0e4cdc"
	],
	"./template9/Noodles/template.json": [
		"bed1",
		"chunk-2d21b4c6"
	],
	"./template9/Organic Food/template.json": [
		"04aa",
		"chunk-2d0a421a"
	],
	"./template9/Oriental Cuisine/template.json": [
		"8b39",
		"chunk-2d0e8c06"
	],
	"./template9/Other/template.json": [
		"b1fa",
		"chunk-2d20f200"
	],
	"./template9/Pakistani Cuisine/template.json": [
		"4369",
		"chunk-2d0c0a78"
	],
	"./template9/Pan Asian Restaurant/template.json": [
		"1ed2d",
		"chunk-746264cc"
	],
	"./template9/Peri-Peri/template.json": [
		"2bf8",
		"chunk-2d0bd7f8"
	],
	"./template9/Persian Cuisine/template.json": [
		"48fb",
		"chunk-2d0c2336"
	],
	"./template9/Pizza/template.json": [
		"c7d0",
		"chunk-2d217c76"
	],
	"./template9/Portuguese Cuisine/template.json": [
		"c19c",
		"chunk-2d2160ee"
	],
	"./template9/Roast Dinner/template.json": [
		"66b3",
		"chunk-2d0d03c7"
	],
	"./template9/Salads/template.json": [
		"bd09",
		"chunk-2d21aac1"
	],
	"./template9/Sandwiches/template.json": [
		"a54b",
		"chunk-2d208698"
	],
	"./template9/Sea Food/template.json": [
		"1dd8",
		"chunk-2d0b6add"
	],
	"./template9/Steak/template.json": [
		"f015",
		"chunk-2d22b924"
	],
	"./template9/Subways/template.json": [
		"9c67",
		"chunk-2d0f0481"
	],
	"./template9/Sushi/template.json": [
		"8955",
		"chunk-2d0df257"
	],
	"./template9/Thai Cuisine/template.json": [
		"e022",
		"chunk-2d2244e1"
	],
	"./template9/Turkish Cuisine/template.json": [
		"0cf9",
		"chunk-2d0af2fc"
	],
	"./template9/Vegetarian/template.json": [
		"b5a5",
		"chunk-2d21003d"
	],
	"./template9/Waffles/template.json": [
		"bb06",
		"chunk-2d21a33c"
	],
	"./template9/juice bar/template.json": [
		"99ded",
		"chunk-74bf26ad"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7fcd";
module.exports = webpackAsyncContext;